import classes from "./classes.module.scss";
import Link from "next/link";
import { Routes, buildRoute } from "@Front/Config/Routes";
import { ELegalOptions } from "@Front/Components/LayoutTemplates/DefaultLegalDashboard";
import VerticalSeparator from "@Assets/Icons/vertical-separator.svg";
import Image from "next/image";
import { publicFooterCopyrightLabel } from "@Front/Utils/ensoPublicUiFeatures";

type IProps = {
	className?: string;
};

export default function Desktop({ className }: IProps): React.ReactElement {
	const legalPagesBase = Routes.pages.Legal.LegalInformations;
	return (
		<div className={[classes["sub-root"], className].join(" ")}>
			<Link href={buildRoute(legalPagesBase, { legalUid: ELegalOptions.LEGAL_MENTIONS })}>{publicFooterCopyrightLabel()}</Link>
			<Image src={VerticalSeparator} alt="Separator" />
			<Link href={buildRoute(legalPagesBase, { legalUid: ELegalOptions.CGU })}>Juridiques</Link>
			<Image src={VerticalSeparator} alt="Separator" />
			<Link href={buildRoute(legalPagesBase, { legalUid: ELegalOptions.POLITIQUE_DE_CONFIDENTIALITE })}>
				Politique de confidentialité
			</Link>
			<Image src={VerticalSeparator} alt="Separator" />
			<Link href={buildRoute(legalPagesBase, { legalUid: ELegalOptions.POLITIQUE_DE_GESTION_DES_COOKIES })}>
				Politique des cookies
			</Link>
		</div>
	);
}
